import type { Enabled, UseMutationOptions } from '@tanstack/vue-query'
import { useMutation as _useMutation } from '@tanstack/vue-query'

export function useMutation<
TData = unknown,
    TError = unknown,
    TVariables = void,
    TContext = unknown
        >(options: UseMutationOptions<TData, TError, TVariables, TContext> & { enabled?: Enabled }) {
    return _useMutation<TData, TError, TVariables, TContext>(options)
}
